import React from "react";
import styled from "@emotion/styled";
import { Button, ButtonProps, Typography } from "@mui/material";
import { PlusIcon } from "src/Icons";

const ButtonAdd = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px dashed #D6D6DB",
  height: "32px",
  width: "100%",
  color: "#3A3A57",
  borderRadius: "6px",
  cursor: "pointer",
  userSelect: "none",
  marginTop: "16px",

  "&:hover, &:active": {
    borderColor: "#B9B9B9",
    backgroundColor: "#FAFAFA",
  },
});

interface ButtonAddOutlinedProps {
  onClick?: any;
  title?: string;
  rightIcon?: any;
  leftIcon?: any;
  sx?: any;
}

export function ButtonAddOutlined ({
  onClick,
  title,
  rightIcon,
  leftIcon,
  sx,
  ...rest
}: ButtonAddOutlinedProps & ButtonProps) {
  return (
    <ButtonAdd onClick={onClick} sx={{ ...sx }} disableRipple {...rest}>
      {leftIcon && leftIcon}
      <Typography
        sx={{
          fontSize: sx?.fontSize ? sx?.fontSize : "14px",
          fontWeight: sx?.fontWeight ? sx?.fontWeight : "400",
          margin: "0 8px 0",
          color: sx?.color,
        }}
      >
        {title}
      </Typography>
      {rightIcon && rightIcon}
    </ButtonAdd>
  );
}
